module.exports = __webpack_public_path__ + "fonts/iconfont.4128483f.woff2";